import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Hero from '../components/Hero';
import Story from '../components/Story';
import Story2 from '../components/Story2';
import Footer from '../components/Footer';

import './Home.css';

export default class Home extends React.Component {

  static propTypes = {
    className: PropTypes.string
  };

  render() {
    return (
      <div className={classnames('Home', this.props.className)}>
        <Hero/>
        <Story/>
        <Story2/>
        <Footer/>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Home.js